export const LAYOUT_APP_BAR_HEIGHT_PX = 52
export const SIDEBAR_WIDTH_PX = 224
export const SIDEBAR_COLLAPSED_WIDTH_PX = 52
export const SIDEBAR_STORAGE_KEY = 'nhansu-sidebar-open'
